import { Box, Button, Divider, Grid, Stack, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { LabeledText } from '../../../../../../components/CustomTypography'
import { StyledCard } from '../../../../../../components/StyledCard'

interface GrantsMetricsProps {
  metrics: { label: string; value: number }[]
  actionButtons?: { [key: string]: ReactNode }
}

export const GrantsMetrics: FC<GrantsMetricsProps> = ({ metrics, actionButtons }) => {
  const navigate = useNavigate()

  return (
    <StyledCard sx={{ mt: 1.5 }}>
      <Grid container spacing={2} height="100%">
        {metrics &&
          metrics.map((metric, index) => {
            return (
              <Grid
                item
                xs={12}
                sm={2}
                key={metric.label}
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
              >
                <Stack direction="row" gap={1}>
                  <LabeledText
                    label={metric.label}
                    value={metric.value.toString()}
                    labelProps={{ fontSize: '1rem', fontWeight: 500 }}
                    valueProps={{ fontSize: '1.2rem', fontWeight: 600 }}
                    rootContainerProps={{ direction: 'column', alignItems: 'flex-start' }}
                  />

                  {actionButtons && <Box>{actionButtons[metric.label]}</Box>}
                </Stack>

                {index < metrics.length - 1 && <Divider orientation="vertical" />}
              </Grid>
            )
          })}

        <Grid item sm={6} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <StyledCard
            sx={{
              p: 2,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: 'success.light',
            }}
          >
            <Typography fontSize="0.9rem" fontWeight={500} color="secondary">
              Want more grants? Visit browse tab.
            </Typography>

            <Button
              variant="contained"
              disableElevation={true}
              onClick={() => navigate('/browse')}
              sx={{ borderRadius: '8px', textTransform: 'none' }}
            >
              Browse now
            </Button>
          </StyledCard>
        </Grid>
      </Grid>
    </StyledCard>
  )
}
